<app-page-title titleHeading='Cards examples 5' titleDescription='Wide selection of cards with multiple styles, borders, actions and hover effects.'></app-page-title>

<app-example-wrapper-seamless sectionHeading="Cards 29">
    <app-cards5-examples-29></app-cards5-examples-29>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 30">
    <app-cards5-examples-30></app-cards5-examples-30>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 31">
    <app-cards5-examples-31></app-cards5-examples-31>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 32">
    <app-cards5-examples-32></app-cards5-examples-32>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 33">
    <app-cards5-examples-33></app-cards5-examples-33>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 35">
    <app-cards5-examples-35></app-cards5-examples-35>
</app-example-wrapper-seamless>

